import { cn } from '@/utils/cn';
import { ButtonHTMLAttributes } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

export interface CustomButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

export const Button = ({
  className,
  children,
  disabled,
  loading,
  type = 'button',
  ...props
}: CustomButtonProps) => {
  return (
    <button
      className={cn(
        'flex items-center justify-center gap-2 rounded-md bg-secondary px-4 py-2 text-sm font-medium text-white transition-colors',
        (disabled || loading) && 'cursor-not-allowed opacity-50',
        className,
      )}
      disabled={disabled || loading}
      type={type}
      {...props}
    >
      {loading && <AiOutlineLoading3Quarters className="size-4 animate-spin" />}
      {children}
    </button>
  );
};
